// Planilha de Produtos (Cardápio → Produtos → Planilha): exportar o cardápio
// inteiro e importar preço, descrição, fiscal e produtos novos de volta.
import axios from "axios";

export { mensagemDeErro } from "../fiscal/api/planilhaFiscal";

const URL_PLANILHA = "/api/products/planilha";

const auth = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
});

/** Baixa o .xlsx. A rota é autenticada, então o download passa pelo axios
 *  (um <a href> direto não mandaria o Bearer). */
export async function baixarPlanilha() {
  const res = await axios.get(URL_PLANILHA, { ...auth(), responseType: "blob" });
  const nome = /filename="([^"]+)"/.exec(res.headers["content-disposition"] || "")?.[1] || "produtos.xlsx";
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = nome;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

/** Sem `confirmar` devolve só a prévia; com `confirmar` grava.
 *  `categorias`: {linha: categoria} escolhidas para produto novo sem categoria. */
export async function enviarPlanilha(arquivo, confirmar, categorias = {}) {
  const form = new FormData();
  form.append("arquivo", arquivo);
  form.append("confirmar", confirmar ? "true" : "false");
  form.append("categorias", JSON.stringify(categorias));
  const { data } = await axios.post(URL_PLANILHA, form, auth());
  return data;
}
